var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-reports',{key:"label-reports",attrs:{"type":"label","getter-key":"labels/getLabels","action-key":"labels/get","download-button-label":_vm.$t('LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS')}})
}
var staticRenderFns = []

export { render, staticRenderFns }